export default __webpack_public_path__ + "14d2698739274f18ccd199f2828915b1.svg";